/*
 * @Author: v-fmasoud@tableau.com
 * @Date: 2017-10-10 11:21:56
 * @Last Modified by: v-fmasoud@tableau.com
 * @Last Modified time: 2018-04-10 12:38:22
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Header from './Header';
import Footer from './Footer';
import Navigation from './Navigation';

class Layout extends Component {
  render() {
    const { bare, children } = this.props;
    // Bare layout (freemium public auth flows): keep the branded header but
    // suppress the auth links, marketing subnav and footer.
    if (bare) {
      return (
        <div>
          <Header hideAuthLinks />
          <hr className="divider divider--gradient" />
          {children}
        </div>
      );
    }
    return (
      <div>
        <Header />
        <Navigation />
        <hr className="divider divider--gradient" />
        {children}
        <Footer />
      </div>
    );
  }
}
Layout.propTypes = {
  children: PropTypes.any.isRequired,
  bare: PropTypes.bool,
};

Layout.defaultProps = {
  bare: false,
};

export default Layout;
